import React, { useCallback, useState } from 'react'
import TableSkeleton from '../../TableSkeleton/TableSkeleton'
import { ReactComponent as DeclineIcon } from '../../../assets/images/decline.svg'
import { ReactComponent as ApproveIcon } from '../../../assets/images/approve-icon.svg'
import { ReactComponent as IconView } from '../../../assets/images/icons/icon-view-black.svg'
import { ReactComponent as IconsDots } from '../../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconDelete } from '../../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconApproveRight } from '../../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../../assets/images/icons/icon-close-desaprrove.svg'
import TableListing from '../../TableListing/TableListing'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'
import requestApi from '../../../utils/request'
import PaginationItem from '../../Pagination/Pagination'
import { productcatalog } from '../../../config/routingConsts'
import NoRecordFound from '../../NoRecordFound/NoRecordFound'

const VendorProductTab = () => {
    const navigate = useNavigate()
    const { sellerId } = useParams()
    const [Active, setActive] = useState('')
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [sorting, setSorting] = useState([])
    const [filter, setFilter] = useState(null)

    function ProductLisitng({ queryKey }) {
        return requestApi
            .post(
                `catalog/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: queryKey[4]?.sortKey,
                    sortBy: queryKey[4]?.sortBy,
                    status: queryKey[5],
                    sellerId: queryKey[6]
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: [
            'productlist',
            currentPage,
            DataLimit,
            searchKeyword,
            filter,
            Active,
            sellerId
        ],
        queryFn: ProductLisitng
    })

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    //#region  Colunms
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row?.productName, {
            id: 'productName',
            header: () => 'Name',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.productName
                            ? row?.row?.original?.productName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.mainCategoryName, {
            id: 'mainCategoryName',
            header: () => 'Main Category',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.mainCategoryName
                            ? row?.row?.original?.mainCategoryName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.categoryName, {
            id: 'categoryName',
            header: () => 'Category',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.categoryName
                            ? row?.row?.original?.categoryName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.productWeight, {
            id: 'productWeight',
            header: () => 'Weight (gms)',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.productWeight
                            ? row?.row?.original?.productWeight
                            : '-'}
                    </span>
                )
            }
        }),
            columnHelper.accessor((row) => row?.note, {
                id: 'note',
                header: () => 'Note',
                cell: (row) => 
                {
                    if(row?.row?.original?.note ===""){
                        return <span>-</span>
                    }else{
                        return <span>{row?.row?.original?.note}</span> 
                    }
                }
            }),
        columnHelper.accessor((row) => row?.status, {
            id: 'status',
            header: () => 'Status',
            cell: (row) => {
                switch(row?.row?.original?.status)
                {
                    case 5:
                        return <span className='decline-data status-data'>Rejected</span>
                    case 1:
                        return <span className='active-data status-data'>Active</span>
                    case 2: 
                        return <span className='in-active-data status-data'>In-Active</span>    
                    case 7:
                        return <span className='pending-data status-data'>Panding</span>    
                }
            }
        }),
        columnHelper.display({
            id: 'action',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                          {/* <div className="action-data">
                          <div
                                className={`table-action ${
                                    row?.row?.original?.id === openAction
                                        ? 'active'
                                        : ''
                                }`}
                                onMouseLeave={() => setopenAction(null)}
                            >
                                <div
                                    className={`action-btn ${
                                        row?.row?.original?.id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        OpenAction(row?.row?.original?.id)
                                    }
                                >
                                    <IconsDots />
                                </div>
                                <div className="action-panel two-action">
                                <div
                                    className="action-btn-icon view"
                                    onClick={() => {
                                        navigate(
                                            `${productcatalog}/${row?.row?.original?.id}`,
                                            {
                                                state:'designerview'
                                            }
                                        )
                                    }}
                                >
                                    <IconView  />
                                </div>
                                </div>
                            </div> 

                        </div>*/}
                            <IconView 
                             data-toggle="tooltip"
                             data-placement="top"
                             title={`View ${row?.row?.original?.productName}'s Detail`}
                                     onClick={() => {
                                        navigate(
                                            `${productcatalog}/${row?.row?.original?.id}`,
                                            {
                                                state:'designerview'
                                            }
                                        )
                                    }}
                                    />
                    </>
                )
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data || [],
        columns: columns,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    console.log(filter,"filter");

    return (
        <>
            <div className="admin-card">
                <div className="head">
                    <h2>Products List</h2>
                </div>
                {isLoading ? (
                    <div>
                        <TableSkeleton />
                    </div>
                ) : data?.data?.length > 0 ? (
                    <>
                        <TableListing table={table} className="m-0" 
                         parentLink={productcatalog}  keyValue="id"
                         isLink excludes={['action']}
                         getfilter={(e) => {setFilter(e)}}
                         />
                        <div className="pagination-wrap">
                            <div className="showing-pages">
                                <span>
                                    Showing {(currentPage - 1) * DataLimit + 1}{' '}
                                    to{' '}
                                    {Math.min(
                                        currentPage * DataLimit,
                                        data.meta.totalCount
                                    )}{' '}
                                    of {data.meta.totalCount}{' '}
                                    {data.meta.totalCount === 1
                                        ? 'Product'
                                        : 'Products'}
                                </span>
                            </div>
                            {data?.meta?.totalCount > 10 && (
                                <>
                                    {/* <div className="itemperpage-box">
                                        <span>Items per page:</span>

                                        <Dropdown onSelect={handleChange}>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {DataLimit}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="10">
                                                    10
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="20">
                                                    20
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="30">
                                                    30
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> */}

                                    <PaginationItem
                                        total={Math.ceil(
                                            data.meta.totalCount / DataLimit
                                        )}
                                        current={currentPage}
                                        onChangePage={handleChangePage}
                                    />
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    
                <div className="no-record-found">
                    {/* No Products Available */}
                    <NoRecordFound />
                    </div>
                )}
            </div>
        </>
    )
}

export default React.memo(VendorProductTab)
